module.exports = __webpack_public_path__ + "img/game_area_address_preview.e037f3ec.png";